/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Api_UrlInputs */

const vi_einvoice_settings_api_url = /** @type {(inputs: Einvoice_Settings_Api_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API URL`)
};

/**

* @param {Einvoice_Settings_Api_UrlInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_api_url = /** @type {((inputs?: Einvoice_Settings_Api_UrlInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Api_UrlInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_api_url(inputs)
});